export default function validateRegex(value, regex) {
  return regex.test(value)
}